import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//** 403 errors on portal will automatically get this component. Route is 'portal/permission-denied' */

@Component({
  selector: 'app-permission-denied',
  template: `
    @if (showToolbar) {
      <app-toolbar></app-toolbar>
    }
    <div class="permission-denied-container">
      <h1>Permission denied</h1>
      @if (message) {
        <p class="ml-1 mr-1">{{ message }}</p>
      }
    </div>
  `,
  styles: [
    `
      .permission-denied-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 70vh;
        width: 100%;
      }
    `
  ],
  standalone: false
})
export class PermissionDeniedComponent implements OnInit {
  showToolbar: boolean;
  message: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    router: Router
  ) {
    const state = router.currentNavigation()?.extras?.state;
    if (!state) {
      return; //keep this in constructor. Moving to on-init then router.getCurrentNavigation() return null
    }
    this.message = state.message;
  }

  ngOnInit() {
    this.showToolbar = this.activatedRoute.snapshot.data?.showToolbar;
  }
}
